import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import { AiOutlineForm } from "react-icons/ai";

const CheckinCheckoutOptions = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');

    useEffect(() => {
        const storedUsername = localStorage.getItem("apUsername");
        if (storedUsername) {
            setUsername(storedUsername);
        }
    }, []);

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Header */}
            <div className="bg-teal-600 text-white p-4 shadow-md">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                        <button onClick={() => navigate('/home')} className="text-white hover:text-gray-200">
                            <BiArrowBack size={24} />
                        </button>
                        <h1 className="text-2xl font-bold">Checkout / Checkin</h1>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center">
                            <span className="text-teal-600 font-bold text-lg">
                                {username ? username.charAt(0).toUpperCase() : 'U'}
                            </span>
                        </div>
                        <span className="font-semibold">{username || 'User'}</span>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] px-4">
                <button
                    onClick={() => navigate('/checkout-form')}
                    className="flex flex-row gap-4 w-full max-w-md px-4 py-4 bg-teal-600 text-white items-center justify-center rounded-lg hover:bg-teal-700 transition-colors mb-8"
                >
                    <AiOutlineForm size={24} />
                    <span className="text-lg font-semibold">Checkout Form</span>
                </button>

                <button
                    onClick={() => navigate('/checkin-form')}
                    className="flex flex-row gap-4 w-full max-w-md px-4 py-4 bg-teal-600 text-white items-center justify-center rounded-lg hover:bg-teal-700 transition-colors"
                >
                    <AiOutlineForm size={24} />
                    <span className="text-lg font-semibold">Checkin Form</span>
                </button>
            </div>
        </div>
    );
};

export default CheckinCheckoutOptions;

